/* =========================================================================
   artnini — Shopify theme interactions
   Vanilla JS, dependency-free. Wires the ported "artnini" design
   (index.html / app.js) to Shopify's AJAX cart endpoints.

   Reuses the EXACT class names / ids from index.html:
     #cart-btn  #cart-count  #drawer  #drawer-back  #drawer-body
     #drawer-close  #drawer-close-2  #drawer-total  #checkout-btn
     .drawer .drawer-item .ph .di-body .di-name .di-meta .qm .price
     .remove .ship-bar .ship-progress .ship-fill .drawer-empty
     #toast  #toast-msg

   Add-to-cart contract (emitted by the product-card snippet & product
   template): any clickable carrying [data-variant-id]. Quantity is read
   from the sibling `.qm input` when present, else 1. The product page
   form (form[action^="/cart/add"]) is intercepted on submit.
   ========================================================================= */
(function () {
  "use strict";

  var SHIP_THRESHOLD = 5000; // 50,00 € expressed in cents (livraison offerte)

  /* ---- tiny helpers ---------------------------------------------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var ESC_MAP = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return ESC_MAP[c]; }); }

  // Shopify /cart.js returns prices in cents. Format like the original
  // fmt(): "12,50 €". If the theme exposes a Shopify money_format string
  // (window.themeMoneyFormat) we honour its currency symbol placement.
  function fmt(cents) {
    var n = (Number(cents) || 0) / 100;
    var body = n.toFixed(2).replace(".", ",");
    var f = window.themeMoneyFormat;
    if (typeof f === "string" && f.indexOf("{{") !== -1) {
      // Replace any {{ amount... }} token with our comma-formatted value.
      return f.replace(/\{\{\s*amount[^}]*\}\}/g, body);
    }
    return body + " €";
  }

  /* ---- drawer open / close (mirrors app.js openDrawer/closeDrawer) ------ */
  var drawer = $("#drawer");
  var drawerBack = $("#drawer-back");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    if (drawerBack) drawerBack.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    if (drawerBack) drawerBack.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
  }

  var cartBtn = $("#cart-btn");
  if (cartBtn) cartBtn.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); refreshCart(); });
  var dClose = $("#drawer-close");
  if (dClose) dClose.addEventListener("click", closeDrawer);
  var dClose2 = $("#drawer-close-2");
  if (dClose2) dClose2.addEventListener("click", closeDrawer);
  if (drawerBack) drawerBack.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---- toast (reuses #toast / #toast-msg) ------------------------------ */
  var toast = $("#toast");
  var toastMsg = $("#toast-msg");
  var toastTimer;
  function showToast(msg) {
    if (!toast || !toastMsg) return;
    toastMsg.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2600);
  }

  /* ---- checkout -------------------------------------------------------- */
  var checkoutBtn = $("#checkout-btn");
  if (checkoutBtn) checkoutBtn.addEventListener("click", function () { window.location.href = "/checkout"; });
  window.checkout = function () { window.location.href = "/checkout"; };

  /* ---- free-shipping progress bar (matches renderShipBar) -------------- */
  function renderShipBar(total) {
    if (!total || total <= 0) return "";
    var neargo = '<a href="https://neargo.eu" target="_blank" rel="noopener" class="ship-neargo"><span>🍃 Livré par neargo</span><span>→</span></a>';
    if (total >= SHIP_THRESHOLD) {
      return '<div class="ship-bar unlocked">' +
        '<div class="ship-text"><span class="check">✓</span> Livraison offerte débloquée</div>' +
        '<div class="ship-progress"><div class="ship-fill" style="width:100%"></div></div>' +
        neargo + '</div>';
    }
    var left = SHIP_THRESHOLD - total;
    var pct = Math.max(4, Math.min(100, (total / SHIP_THRESHOLD) * 100));
    return '<div class="ship-bar">' +
      '<div class="ship-text"><span>🚚</span><span>Plus que <strong>' + fmt(left) + '</strong> pour la livraison offerte</span></div>' +
      '<div class="ship-progress"><div class="ship-fill" style="width:' + pct + '%"></div></div>' +
      neargo + '</div>';
  }

  /* ---- drawer line item (mirrors updateCart() markup) ------------------ */
  function lineHTML(item) {
    var key = esc(item.key);
    var qty = parseInt(item.quantity, 10) || 1;
    var img = item.image || (item.featured_image && item.featured_image.url) || "";
    var cat = esc(item.product_type || "");
    var vendor = esc(item.vendor || "");
    var name = esc(item.product_title || item.title || "");

    var phImg = img
      ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async"/>'
      : "";
    var phClass = "ph" + (img ? " has-img" : "");

    return '' +
      '<div class="drawer-item">' +
        '<div class="' + phClass + '" data-cat="' + cat + '">' + phImg + '</div>' +
        '<div class="di-body">' +
          '<p class="di-name">' + name + '</p>' +
          (vendor
            ? '<div class="sub" style="font-size:11px;color:var(--muted);letter-spacing:.04em;text-transform:uppercase;font-weight:600;display:flex;gap:8px;align-items:center;"><span>' + vendor + '</span></div>'
            : "") +
          '<div class="di-meta">' +
            '<div class="qm">' +
              '<button type="button" aria-label="-" data-line-change data-key="' + key + '" data-delta="-1">−</button>' +
              '<input type="text" inputmode="numeric" value="' + qty + '" data-line-qty data-key="' + key + '" ' +
                'oninput="this.value=this.value.replace(/[^0-9]/g,&#39;&#39;).slice(0,4)" ' +
                'onkeydown="if(event.key===&#39;Enter&#39;){event.preventDefault();this.blur()}" />' +
              '<button type="button" aria-label="+" data-line-change data-key="' + key + '" data-delta="1">+</button>' +
            '</div>' +
            '<div style="text-align:right">' +
              '<span class="price">' + fmt(item.final_line_price != null ? item.final_line_price : item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="di-meta">' +
            '<span style="font-size:11px">' + fmt(item.final_price != null ? item.final_price : item.price) + ' × ' + qty + '</span>' +
            '<button class="remove" data-line-remove data-key="' + key + '" aria-label="Retirer">×</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  /* ---- render the whole drawer from a Shopify cart object -------------- */
  function renderCart(cart) {
    var count = cart.item_count || 0;
    var countEl = $("#cart-count");
    if (countEl) countEl.textContent = count;

    var body = $("#drawer-body");
    if (body) {
      var prevScroll = body.scrollTop;
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<div class="drawer-empty">Votre panier est vide.<br/>Ajoutez vos essentiels de bureau.</div>';
      } else {
        var items = cart.items.map(lineHTML).join("");
        body.innerHTML = renderShipBar(cart.total_price) + items;
      }
      body.scrollTop = prevScroll;
    }

    var totalEl = $("#drawer-total");
    if (totalEl) totalEl.textContent = fmt(cart.total_price);

    var cbtn = $("#checkout-btn");
    if (cbtn) {
      var empty = count === 0;
      // #checkout-btn is an <a>: `disabled` has no effect, and the Liquid
      // template inlines pointer-events:none when the cart starts empty —
      // clear/restore it here or the button stays dead after an AJAX add.
      cbtn.style.pointerEvents = empty ? "none" : "auto";
      cbtn.setAttribute("aria-disabled", empty ? "true" : "false");
      cbtn.style.opacity = empty ? 0.5 : 1;
      cbtn.style.cursor = empty ? "not-allowed" : "";
    }
  }

  /* ---- cart network ops ------------------------------------------------ */
  function getCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
  }
  function refreshCart() {
    return getCart().then(renderCart).catch(function () {});
  }

  function addToCart(variantId, quantity) {
    quantity = parseInt(quantity, 10) || 1;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function (line) {
      // Toast + badge update only — the drawer opens ONLY via the cart button,
      // so adding products never yanks the customer out of their browsing flow.
      showToast("Ajouté au panier : " + (line && line.product_title ? line.product_title : "") + (quantity > 1 ? " (" + quantity + "×)" : ""));
      return refreshCart();
    }).catch(function (err) {
      showToast((err && err.description) || "Produit indisponible");
    });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, parseInt(quantity, 10) || 0) })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  // Expose a couple of hooks in case Liquid markup wants inline handlers.
  window.addToCart = addToCart;
  window.openDrawer = openDrawer;
  window.closeDrawer = closeDrawer;

  /* ---- event delegation: add buttons ---------------------------------- */
  // Any element carrying [data-variant-id] adds to cart. Quantity is read
  // from the nearest .qm input (card or product form) when present.
  document.addEventListener("click", function (e) {
    var addEl = e.target.closest && e.target.closest("[data-variant-id]");
    if (addEl) {
      // Ignore clicks that live inside a real <form> submit path — the form
      // submit handler below owns those.
      if (addEl.tagName === "BUTTON" && addEl.type === "submit" && addEl.closest("form[action^='/cart/add']")) return;
      e.preventDefault();
      var variantId = addEl.getAttribute("data-variant-id");
      if (!variantId) { showToast("Produit indisponible"); return; }
      var scope = addEl.closest(".qa") || addEl.closest(".card") || addEl.closest(".mb-buy") || document;
      var qtyInput = scope.querySelector(".qm input");
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(variantId, qty);
      return;
    }

    /* ---- drawer quantity +/- ---- */
    var chg = e.target.closest && e.target.closest("[data-line-change]");
    if (chg) {
      e.preventDefault();
      var key = chg.getAttribute("data-key");
      var delta = parseInt(chg.getAttribute("data-delta"), 10) || 0;
      var input = $('[data-line-qty][data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      var current = input ? parseInt(input.value, 10) || 1 : 1;
      changeLine(key, current + delta);
      return;
    }

    /* ---- drawer remove ---- */
    var rm = e.target.closest && e.target.closest("[data-line-remove]");
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute("data-key"), 0);
      return;
    }

    /* ---- local .qm +/- steppers (card & product page qty box) ---- */
    var stepBtn = e.target.closest && e.target.closest(".qm > button");
    if (stepBtn && !stepBtn.hasAttribute("data-line-change")) {
      var box = stepBtn.parentElement;
      var inp = box.querySelector("input");
      if (inp) {
        var isPlus = stepBtn.hasAttribute("data-qm-plus");
        var v = parseInt(inp.value, 10) || 1;
        v = isPlus ? v + 1 : Math.max(1, v - 1);
        inp.value = v;
      }
    }
  });

  /* ---- drawer quantity: commit on manual edit ------------------------- */
  document.addEventListener("change", function (e) {
    var input = e.target.closest && e.target.closest("[data-line-qty]");
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (!q || q < 1) q = 1;
    changeLine(input.getAttribute("data-key"), q);
  });

  /* ---- product page form submit --------------------------------------- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute("action") || "";
    if (action.indexOf("/cart/add") === -1) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var variantId = idField ? idField.value : null;
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    if (!variantId) { showToast("Produit indisponible"); return; }
    addToCart(variantId, qty);
  });

  /* ---- initial hydrate ------------------------------------------------- */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshCart);
  } else {
    refreshCart();
  }
})();
